import AbpBase from "@/lib/abpbase";
export default class vueformmodel
    extends AbpBase 
{
    //下拉判断
    selectvalidate = (rule, value, callback) => {
       
        if (Number.isInteger(+value)&&value>0) {
            callback();
        } else {
            callback(new Error(rule.message));
        }
    };
    //判断数字
    DecimalValidate=(rule,value,callback)=>{
        let re = /^[+-]{0,1}[0-9]+.?[0-9]*$/; //判断字符串是否为数字 //判断正整数 /^[1-9]+[0-9]*]*$/
　　    if (!re.test(value)) {
    　　　　callback(new Error('该字符为非数字'));
　　    }else{
            callback();
        }
    }
    //判断整数
    NumValidate=(rule,value,callback)=>
    {
        let re=/^[1-9]+[0-9]*]*$/
        if(!re.test(value))
        {
            callback(new Error('该字符非整数')); 
        }
        else
        {
            callback();
        }
    }
    
    //判断手机号码
    PhoneValidate=(rule,value,callback)=>
    {
        let reg = /^1[3|4|5|7|8][0-9]{9}/;
        if(!reg.test(value)){
            callback(new Error(rule.message)); 
        }
        else
        {
            callback();
        }
    }



    linkvalidate=(rule,value,callback)=>
    {
        
    }
    get allunits()
    {
      return ["件","个","箱"];
    }
  
    get season()
    {
        return ["春","夏","秋","冬"];
    }
  
    get allyears()
    {
        var curyear=1990;
        var myDate =new Date();
        var tYear = myDate.getFullYear();
        var allyear=[];
        for(var i=curyear;i<tYear+1;i++)
        {
            allyear.push(i);
        }
        return allyear;
    }
}